import { FC } from "react";
import { Skeleton } from "antd";
import { BaseFilter } from "src/constants";
import Section from "../layout/Section";

const DynamicFilters: FC<{
  dataGroups: Map<string, Map<number | string, any[]>>;
  filters: BaseFilter[];
  filterComponents: any;
  isFetching?: boolean;
}> = ({
  dataGroups,
  filters,
  filterComponents,
  isFetching,
}) => {
  return filters.map((filter) => {
    const group = dataGroups.get(filter.key);
    if (!group || group.size === 0) return null;

    const { Component } = filterComponents[filter.component as keyof typeof filterComponents];

    if (!Component) return null;

    return (
      <Section label={filter.title} key={filter.key}>
        {isFetching
          ? <Skeleton.Input active classNames={{ content: "h-full!", root: "h-4!" }} />
          : <Component valuesMap={group} filter={filter} />
        }
      </Section>
    );
  });
};

export default DynamicFilters;
